import React, {useEffect,useState} from 'react';
import {countryConfigurationContext,countryConfigurationKey,loadCountryConfiguration} from '../../api/countryConfiguration';

export default function CheckoutSeller({countryId,deliveryCountry}) {
    const [version,setVersion] = useState(0);
    const [result,setResult] = useState(null);
    const context = countryConfigurationContext({countryId:localStorage.getItem('country_id') || countryId,deliveryCountry});
    const key = countryConfigurationKey(context);
    useEffect(() => {
        const refresh = event => {
            if (event.type !== 'storage' || ['country_id','country_code','currency_code'].includes(event.key)) {setResult(null);setVersion(value => value + 1);}
        };
        for (const event of ['country-changed','currency-changed','delivery-country-changed','country-resolution-required','storage']) window.addEventListener(event,refresh);
        return () => {for (const event of ['country-changed','currency-changed','delivery-country-changed','country-resolution-required','storage']) window.removeEventListener(event,refresh);};
    }, []);
    useEffect(() => {
        let active = true;
        setResult(null);
        loadCountryConfiguration({countryId:context.countryId,countryCode:context.countryCode,selectedCountryCode:context.selectedCountryCode,currency:context.currency,deliveryCountry:context.deliveryCountry}).then(data => {
            if (data && active && countryConfigurationKey(countryConfigurationContext({countryId:localStorage.getItem('country_id') || countryId,deliveryCountry})) === key) setResult({key,data});
        });
        return () => {active = false;};
    }, [key,version]); // eslint-disable-line react-hooks/exhaustive-deps
    const data = result?.key === key ? result.data : null;
    if (!data?.legal_tax_profile?.legal_business_name) return null;
    const profile = data.legal_tax_profile;
    return (
        <aside aria-label="Seller details" className="nw-checkout-seller">
            {profile.display_name && profile.display_name !== profile.legal_business_name && (
                <strong className="nw-checkout-seller__brand">{profile.display_name}</strong>
            )}
            <p className="nw-checkout-seller__legal">Sold by {profile.legal_business_name}</p>
        </aside>
    );
}
